export const QuestionTypes = {
	unanswered: 'unanswered',
	answered: 'answered',
};
